import { countryConfig } from '../country';

/**
 * Localize a raw Uzbek-Latin region name via the active country's region catalog.
 * Russian → mapped name; the active country's own locale (or an unrecognized
 * string) → returned unchanged.
 */
export function localizeRegion(name: string | null | undefined, locale: string): string | null {
  return countryConfig.regions.localize(name, locale);
}
